import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=1de19cae&scoped=true"
import script from "./PermissionsTable.vue?vue&type=script&lang=js"
export * from "./PermissionsTable.vue?vue&type=script&lang=js"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=1de19cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de19cae",
  null
  
)

export default component.exports